const ja_messages = require('./ja/messages.json')

const JAPANESE_STRINGS = {
  translation: ja_messages
}

export default JAPANESE_STRINGS
